:host {
  /* background colors **/
  --uui-tag-error-bg-color: var(--uui-theme-error-300);
  --uui-tag-warning-bg-color: var(--uui-theme-warning-400);
  --uui-tag-success-bg-color: var(--uui-theme-success-400);
  --uui-tag-information-bg-color: var(--uui-theme-information-400);

  /* text colors **/
  --uui-tag-error-color: var(--uui-theme-error-600);
  --uui-tag-warning-color: var(--uui-theme-warning-600);
  --uui-tag-success-color: var(--uui-theme-success-600);
  --uui-tag-information-color: var(--uui-theme-information-600);
}

span {
  font-family: var(--uui-primary-font-family);
  font-size: var(--uui-extra-small-font-size);
  font-weight: var(--uui-font-weight-bold);
  line-height: var(--uui-default-font-size);
}

div {
  width: fit-content;
  display: flex;
  border-radius: var(--uui-border-radius-sm);
  padding: var(--uui-xx-small-padding) var(--uui-x-small-padding);
}

:host([variant="error"]) div {
  background-color: var(--uui-tag-error-bg-color);
  color: var(--uui-tag-error-color);
}

:host([variant="warning"]) div {
  background-color: var(--uui-tag-warning-bg-color);
  color: var(--uui-tag-warning-color);
}

:host([variant="success"]) div {
  background-color: var(--uui-tag-success-bg-color);
  color: var(--uui-tag-success-color);
}

:host([variant="information"]) div {
  background-color: var(--uui-tag-information-bg-color);
  color: var(--uui-tag-information-color);
}
